import { useIntl } from 'react-intl';
import { useSelector } from 'react-redux';

import { slices } from '~/redux/slices';
import { Nullable } from '~/types/Nullable';

import { ModelVersion } from '../../types/model';
import { testIsActivePublishStatus } from '../../utils/status';
import { Evaluate } from '../Evaluate';
import { TableConfiguration } from './TableConfiguration';

interface Props {
  modelVersion: Nullable<ModelVersion>;
  entityId: Nullable<string>;
  isConfigDirty: boolean;
}

export const TableDetailsPanel = ({
  modelVersion,
  entityId,
  isConfigDirty,
}: Props) => {
  const intl = useIntl();

  const activeTableModelVersion = useSelector(
    slices.xRay.selectors.selectActiveTableModelVersion,
  );

  const readOnly = Boolean(
    modelVersion && testIsActivePublishStatus(modelVersion.publishStatus),
  );

  return (
    <>
      <TableConfiguration
        isConfigDirty={isConfigDirty}
        modelId={modelVersion?.modelId ?? null}
        entityId={entityId}
        readOnly={readOnly}
        testCases={activeTableModelVersion?.testCases ?? null}
      />
      {activeTableModelVersion && (
        <Evaluate
          isConfigDirty={isConfigDirty}
          modelId={activeTableModelVersion.modelId}
          readOnly={readOnly}
          sectionTitle={intl.formatMessage({
            id: 'Xray.tableModelDetails.evaluateSectionTitle',
            defaultMessage: 'Step 2: Evaluate Table Model',
            description:
              'Title for the evaluate documents section in the table model details.',
          })}
          testCases={activeTableModelVersion.testCases}
          version={activeTableModelVersion.version}
        />
      )}
    </>
  );
};
